export const format = (number, decimals) => {
    if (number === undefined || number === null || isNaN(number)) {
        return "";
    }
    const n = Number(number);
    return n.toLocaleString("de-DE", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
}


